import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María C.',
    location: 'Antofagasta',
    text: 'Me ayudó a comprender situaciones que llevaba años intentando resolver.'
  }, {
    name: 'Carlos R.',
    location: 'Antofagasta',
    text: 'La limpieza energética transformó completamente el ambiente de mi hogar.'
  }, {
    name: 'Sofía L.',
    location: 'Antofagasta',
    text: 'Recibí orientación clara y útil para tomar decisiones importantes.'
  }, {
    name: 'Patricia M.',
    location: 'Antofagasta',
    text: 'Una experiencia profesional, respetuosa y muy reveladora.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95,
      y: 20
    },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative z-10 bg-mystic-black/50 border-y border-mystic-gold/10" data-id="element-215">
      <div className="max-w-7xl mx-auto" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-217">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-218">
            Experiencias de quienes{' '}
            <span className="text-gradient-gold" data-id="element-219">ya consultaron</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-220">
          {testimonials.map((testimonial, index) => <motion.div key={index} variants={cardVariants} className="glass-panel p-8 rounded-2xl relative group hover:border-mystic-gold/30 transition-colors duration-300" data-id="element-221">
              <Quote className="absolute top-6 right-6 w-10 h-10 text-mystic-gold/10 group-hover:text-mystic-gold/20 transition-colors duration-300" data-id="element-222" />

              <div className="flex gap-1 mb-6" data-id="element-223">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-mystic-gold fill-mystic-gold" data-id="element-224" />)}
              </div>

              <p className="text-lg text-mystic-white/90 italic mb-8 font-light leading-relaxed" data-id="element-225">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-226">
                <div className="w-10 h-10 rounded-full bg-mystic-blue-800 flex items-center justify-center border border-mystic-gold/30" data-id="element-227">
                  <span className="font-serif font-bold text-mystic-gold" data-id="element-228">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div data-id="element-229">
                  <p className="font-medium text-mystic-white" data-id="element-230">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-mystic-white/50" data-id="element-231">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}